var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"loading"},[_c('span',{style:({'border-color':_vm.color})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }